import React from "react";
import useCountDown from "./useCountDown";


const CountDown = () => {
 const [days, hours, minutes, seconds]  = useCountDown();

  return (
    <div className="flex gap-2 md:gap-4">
      {/* days */}
      <div className="flex flex-col items-center">
        <div className="flex flex-col items-center justify-center bg-primary_color rounded-full w-16 h-16 md:w-36 md:h-36">
          <h1 className="typo-h2 text-3xl md:text-6xl text-white font-semibold text-center leading-relaxed">
            {days}
          </h1>
        </div>
        <h1 className="typo-small-2 text-sm md:text-3xl my-3">Days</h1>
      </div>

      {/* hours */}
      <div className="flex flex-col items-center">
        <div className="flex flex-col items-center justify-center bg-primary_color rounded-full w-16 h-16 md:w-36 md:h-36">
          <h1 className="typo-h2 text-3xl md:text-6xl text-white font-semibold text-center leading-relaxed">
            {hours}
          </h1>
        </div>
        <h1 className="typo-small-2 text-sm md:text-3xl my-3">Hours</h1>
      </div>

      {/* minutes */}
      <div className="flex flex-col items-center">
        <div className="flex flex-col items-center justify-center bg-primary_color rounded-full w-16 h-16 md:w-36 md:h-36">
          <h1 className="typo-h2 text-3xl md:text-6xl text-white font-semibold text-center leading-relaxed">
            {minutes}
          </h1>
        </div>
        <h1 className="typo-small-2 text-sm md:text-3xl my-3">Minutes</h1>
      </div>

      {/* seconds */}
      <div className="flex flex-col items-center">
        <div className="flex flex-col items-center justify-center bg-primary_color rounded-full w-16 h-16 md:w-36 md:h-36">
          <h1 className="typo-h2 text-3xl md:text-6xl text-white font-semibold text-center leading-relaxed">
            {seconds}
          </h1>
        </div>
        <h1 className="typo-small-2 text-sm md:text-3xl my-3">Seconds</h1>
      </div>
    </div>
  );
};

export default CountDown;
